import { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import useIntersect from '@hooks/useIntersect';
import { IGallerySection } from '@features/productPreview/typescript';
import { WindowType } from '@typescript/index';
import GallerySlider from '@features/productPreview/sections/Gallery/GallerySlider';
import { VisibleSectionType } from '@features/productPreview/const';
import styles from '@features/productPreview/sections/Gallery/GalleryStyles.styles';
import { productPageState, uiState } from '@features/productPreview/mobX/state/context';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import useBodyOverflow from '@hooks/useBodyOverflow';
import { ThemeUIStyleObject } from 'theme-ui';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  section: IGallerySection;
  windowType: WindowType;
};
const GallerySection = ({
  section,
  windowType
}: PropsType) => {
  const {
    setSelectedSlider,
    isOpenModal
  } = uiState;
  const state = productPageState;
  let renderContent: React.ReactNode;
  let sectionStyles: unknown;
  const ref = useRef<HTMLDivElement | null>(null);
  const [isMounted, setIsMounted] = useState(false);
  useBodyOverflow(isOpenModal, 'modal', true, false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const entry = useIntersect(ref, {
    rootMargin: '0px',
    threshold: 0.75
  });
  const inView = !!entry?.isIntersecting;
  useEffect(() => {
    if (inView) {
      state.setActualVisibleSection(VisibleSectionType.PRODUCT_SLIDES);
    }
  }, [inView, state]);
  const images = section.items[0].slides;
  const onClick = windowType === WindowType.desktop ? setSelectedSlider : () => null;

  // NOTE: Fallback content for non-JS environments
  if (!isMounted) {
    return <ErrorBoundary>
        <section id={VisibleSectionType.PRODUCT_SLIDES} sx={styles.sectionSingleImg}>
          <div sx={styles.noJsGallery}>
            {images.map(image => <div key={image.id} sx={styles.imgContainer}>
                <ResponsiveImage alt="" image={image.image[windowType]} objectPosition="center" />
              </div>)}
          </div>
        </section>
      </ErrorBoundary>;
  }
  if (images.length === 1) {
    renderContent = <button type="button" sx={styles.imgContainer} onClick={() => onClick(images[0])}>
        <ResponsiveImage alt="" image={images[0].image.desktop} objectPosition="center" />
      </button>;
    sectionStyles = styles.sectionSingleImg;
  } else {
    renderContent = <GallerySlider slides={images} windowType={windowType} onSelectImage={onClick} />;
    sectionStyles = styles.section;
  }
  return <ErrorBoundary>
      {images.length !== 0 && <section id={VisibleSectionType.PRODUCT_SLIDES} ref={ref} sx={sectionStyles as ThemeUIStyleObject}>
          {renderContent}
        </section>}
    </ErrorBoundary>;
};
export default observer(GallerySection);